/**
 * Created by Vladislav on 12.02.2026.
 */

const ReturnAction = cleverapps.throttle(250, () => {
    const currentWindow = cleverapps.focusManager.currentWindow();

    if (cleverapps.rewardedAdsManager.adIsRunning()) {
        return;
    }

    if (cleverapps.config.debugMode) {
        if (cleverapps.sceneDebugger && cleverapps.sceneDebugger.selectedNode) {
            cleverapps.sceneDebugger.unselectNodes();
            return;
        }
    }

    if (currentWindow && !currentWindow.closed) {
        if (currentWindow.closeByHardwareBackButton) {
            currentWindow.closeByHardwareBackButton();
            return;
        }

        if (cleverapps.config.debugMode) {
            if (cleverapps.forces.isRunningForce() && (!cleverapps.tutorial || !cleverapps.tutorial.isActive())) {
                cleverapps.forces.closeRunningForce();
            }
        }
        return;
    }

    // toolModel only exists in debug builds - there Esc/back toggles the tool instead of leaving the scene
    if (cleverapps.toolModel && !(cleverapps.Scenes.GetRunningScene() instanceof AdministratorScene)) {
        if (cleverapps.toolModel.isOpened()) {
            cleverapps.toolModel.hide();
        } else {
            cleverapps.toolModel.show();
        }
        return;
    }

    const scene = cleverapps.Scenes.GetRunningScene();
    if (scene && !(scene instanceof LoaderScene)) {
        scene.sceneComponent.closeAction();
    }
});